import React, { Component, Fragment } from "react";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { ai } from "./telemetryService";
import { withRouter } from "react-router-dom";

// Dev environments seed REACT_APP_CONNECTIONSTRING with an all-zero
// InstrumentationKey placeholder. If we hand that to App Insights it spams
// HTTP 400s against the ingestion endpoint forever, so skip init in that case.
const hasRealInstrumentationKey = (connectionString) => {
  if (!connectionString) return false;
  const match = /InstrumentationKey=([0-9a-fA-F-]+)/.exec(connectionString);
  if (!match) return false;
  return match[1].replace(/-/g, "").replace(/0/g, "").length > 0;
};

/**
 * This Component provides telemetry with Azure App Insights
 *
 * NOTE: the package '@microsoft/applicationinsights-react-js' has a HOC withAITracking that requires this to be a Class Component rather than a Functional Component
 */
class TelemetryProvider extends Component {
  state = {
    initialized: false,
  };

  componentDidMount() {
    const { history } = this.props;
    const { initialized } = this.state;
    const AppInsightsConnectionString = this.props.connectionString;
    if (
      !Boolean(initialized) &&
      hasRealInstrumentationKey(AppInsightsConnectionString) &&
      Boolean(history)
    ) {
      ai.initialize(AppInsightsConnectionString, history);
      this.setState({ initialized: true });
    }

    this.props.after();
  }

  render() {
    const { children } = this.props;
    return <Fragment>{children}</Fragment>;
  }
}

export default withRouter(withAITracking(ai.reactPlugin, TelemetryProvider));
